// Angular:
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

// Dependencies:
import {
    TgButtons2Module,
    TgDropdownModule,
    TgIconBasicArrowLeftModule,
    TgIconBasicArrowRightModule,
    TgRackModule,
    TgScrollableContainerModule,
    TgSvgModule,
    TgTeleportModule
} from '@trademe/tangram';
import { StepIndicatorStepButtonComponent } from './step-indicator-step-button/step-indicator-step-button.component';
import { StepIndicatorStepInfoComponent } from './step-indicator-step-info/step-indicator-step-info.component';
import { StepIndicatorTabComponent } from './step-indicator-tab/step-indicator-tab.component';

// Exports:
import { StepIndicatorIconDirective } from './step-indicator-icon/step-indicator-icon.directive';
import { StepIndicatorItemComponent } from './step-indicator-item/step-indicator-item.component';
import { StepIndicatorComponent } from './step-indicator/step-indicator.component';
import { stepIndicatorComponentInjection } from './step-indicator/istep-indicator.component';

@NgModule({
    imports: [
        CommonModule,
        TgButtons2Module,
        TgDropdownModule,
        TgIconBasicArrowLeftModule,
        TgIconBasicArrowRightModule,
        TgRackModule,
        TgScrollableContainerModule,
        TgSvgModule,
        TgTeleportModule
    ],
    declarations: [
        StepIndicatorComponent,
        StepIndicatorIconDirective,
        StepIndicatorItemComponent,
        StepIndicatorStepButtonComponent,
        StepIndicatorStepInfoComponent,
        StepIndicatorTabComponent
    ],
    exports: [
        StepIndicatorComponent,
        StepIndicatorIconDirective,
        StepIndicatorItemComponent
    ],
    providers: [
        {
            provide: stepIndicatorComponentInjection,
            useClass: StepIndicatorComponent
        }
    ]
})
export class TMStepIndicatorModule {}
